module.exports = __webpack_public_path__ + "img/4.fd07b955.png";